import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "redux/navigation/modalStates";
import { Modal } from "reactstrap";

export default function ModalRoot() {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.modal.isOpen);
    const type = useSelector((state) => state.modal.type);
    const props = useSelector((state) => state.modal.props);

    const handleClose = () => {
        dispatch(closeModal());
    };
    
    let ModalComponent = null;
    
    switch (type) {
        case "BUS_DETAILS":
            ModalComponent = require("components/Buses/Modal/detailsModal").default;
            break;
        // Add more cases here for different modal types
        case "ORDER_DETAILS":
            ModalComponent = require("components/Orders/modals/OrderDetails").default;
            break;
        default:
            ModalComponent = null;
    }

    return (
        <>
            {ModalComponent && (
                <ModalComponent isOpen={isOpen} toggle={handleClose} {...props} />
            )}
        </>
    );
}
